// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CorrectiveMaintenanceResultDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class CorrectiveMaintenanceResultApiClient extends BaseCRUDApiClient<CorrectiveMaintenanceResultDto> {
  baseUrl = this.config.apiEndpoint + '/corrective-maintenance-result';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
